import React from 'react';
import { Route, Routes } from 'react-router-dom';
import FlowBuilder from './components/FlowBuilder';
import MetricsBuilder from './components/MetricBuilder';
import DimensionsBuilder from './components/DimensionBuilder';
import ResizablePanel from '@src/emp-3.0/components/ResizablePanel';
import FloatToolsWrapper from './components/FloatToolsWrapper';

const WorkflowRoute = () => {
  return (
    <>
      <ResizablePanel initLeftWidth={710} maxLeftWidth={800}>
        <>
          <Routes>
            <Route path={`/flow/:flowId`} element={<FlowBuilder />} />
            <Route path={`/metric/:metricId`} element={<MetricsBuilder />} />
            <Route path={`/dimension/:id`} element={<DimensionsBuilder />} />
            <Route path={`/rename/:id/*`} element={<DimensionsBuilder />} />
            <Route path={`/pattern/:flowId/*`} element={<FlowBuilder />} />
          </Routes>
        </>
        <>
          <Routes>
            <Route path={`/:type/:id`} element={<FloatToolsWrapper />} />
          </Routes>
        </>
      </ResizablePanel>
    </>
  );
};

export default WorkflowRoute;
